import { render, staticRenderFns } from "./GalleryThumb.vue?vue&type=template&id=0a2fff8d&scoped=true"
import script from "./GalleryThumb.vue?vue&type=script&lang=js"
export * from "./GalleryThumb.vue?vue&type=script&lang=js"
import style0 from "./GalleryThumb.vue?vue&type=style&index=0&id=0a2fff8d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2fff8d",
  null
  
)

export default component.exports